import { IBrokerGroupSummary, IBroker, IPanelLender, IBrokerAudit } from '@/domain/bankwatch';

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const groups = (state: any, groups: IBrokerGroupSummary[]) => {
    state.groups = groups;
}

export const brokers = (state: any, brokers: IBroker[]) => {
    state.brokers = brokers;
}

export const lenders = (state: any, lenders: IPanelLender[]) => {
    state.lenders = lenders;
}

export const panel = (state: any, panel: string[]) => {
    state.panel = panel;
}

export const audit = (state: any, audit: IBrokerAudit[]) => {
    state.audit = audit;
}
